var _path, _path2, _path3, _path4, _path5, _line, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluedelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1426 7.42773L6.2195 13.8563",
    stroke: "#026094",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1426 7.42773L6.2195 13.8563",
    stroke: "#026094",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21875 7.42773L13.1418 13.8563",
    stroke: "#026094",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21875 7.42773L13.1418 13.8563",
    stroke: "#026094",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21875 2.28516H13.1418V2.28516C13.1418 1.57508 12.5662 0.999442 11.8561 0.999442H7.50446C6.79438 0.999442 6.21875 1.57508 6.21875 2.28516V2.28516Z",
    stroke: "#026094"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.17969,
    y1: 3.07227,
    x2: 18.1797,
    y2: 3.07226,
    stroke: "#026094",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.155 2.78516H16.2047C16.4979 2.78516 16.7282 3.03628 16.7028 3.32839L15.4258 18.0427C15.4034 18.3011 15.1871 18.4994 14.9277 18.4994H4.43198C4.17259 18.4994 3.95628 18.3011 3.93385 18.0427L2.65687 3.32839C2.63152 3.03628 2.8618 2.78516 3.155 2.78516Z",
    stroke: "#026094"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluedelete);
export default __webpack_public_path__ + "static/media/bluedelete.1e0b60afd30e672120ee7e620d0583e3.svg";
export { ForwardRef as ReactComponent };